import { ref, Ref } from 'vue';
import { Socket } from 'socket.io-client';
import { StockSocketTransferDTO } from "@/helpers/models/stock/stock_socket_transfer.dto";
import { SOCKET_LOGGING_ENABLED } from '../constants';


export class SocketStateManager {
    private static instance: SocketStateManager;
    socket: Socket | null = null;
    userDataInfo = ref<Record<string, any>>({});
    userIds = ref<string[]>([]);
    predicitionDataInfo = ref<Record<string, any>>({});
    predictionIds = ref<string[]>([]);
    stockIds: StockSocketTransferDTO[] = [];
    stocksData: Record<string, any> = {};
    stocks: any[] = [];
    portfolioSummaryData = ref<any>(null);
    portfoliosCardData = ref<any[]>([]);
    portfolioOverviewData = ref<any>(null);

    private cleanupCallbacks: Function[] = [];
    private activeTimeouts: NodeJS.Timeout[] = [];



    // Debounce state for user IDs
    pendingUserIdsBatch = new Set<string>();
    getUserByIdDebounceTimeout: NodeJS.Timeout | null = null;
    processedUserIds = new Set<string>();
    immediateRequestCache = new Map<string, number>();


    // Debounce state for stocks
  pendingStockIdsBatch = new Set<string>(); // Store stock IDs as strings for deduplication
  getStocksDebounceTimeout: NodeJS.Timeout | null = null;
  processedStockIds = new Set<string>(); // Track already process


    private constructor() { }

    static getInstance(): SocketStateManager {
        if (!SocketStateManager.instance) {
            SocketStateManager.instance = new SocketStateManager();
        }
        return SocketStateManager.instance;
    }

    addCleanup(callback: Function) {
        this.cleanupCallbacks.push(callback);
    }

    addTimeout(timeout: NodeJS.Timeout) {
        this.activeTimeouts.push(timeout);
    }

    clearUserDebounceState() {
        this.pendingUserIdsBatch.clear();
        this.processedUserIds.clear();
        this.immediateRequestCache.clear();
        if (this.getUserByIdDebounceTimeout) {
            clearTimeout(this.getUserByIdDebounceTimeout);
            this.getUserByIdDebounceTimeout = null;
        }
    }

     clearStockDebounceState() {
    this.pendingStockIdsBatch.clear();
    this.processedStockIds.clear();
    if (this.getStocksDebounceTimeout) {
      clearTimeout(this.getStocksDebounceTimeout);
      this.getStocksDebounceTimeout = null;
    }
  }

    cleanup() {
        if (SOCKET_LOGGING_ENABLED) {
            console.log('SocketStateManager: Cleanup', {
                stock: this.stocksData,
                stocks: this.stocks,
                userDataInfo: this.userDataInfo.value,
                userIds: this.userIds.value,
                predicitionDataInfo: this.predicitionDataInfo.value,
                predictionIds: this.predictionIds.value,
                stockIds: this.stockIds,
                portfolioSummaryData: this.portfolioSummaryData.value,
                portfoliosCardData: this.portfoliosCardData.value,
                portfolioOverviewData: this.portfolioOverviewData.value,
                activeTimeout: this.activeTimeouts,
                cleanUpCallBacks: this.cleanupCallbacks
            })
        }
        // this.activeTimeouts.forEach(clearTimeout);
        // this.activeTimeouts = [];
        // this.cleanupCallbacks.forEach(cb => cb());
        // this.cleanupCallbacks = [];
        //this.userDataInfo.value = {};
        //this.userIds.value = [];
        //this.predicitionDataInfo.value = {};
        //this.predictionIds.value = [];
        //this.stockIds = [];
        // this.stocksData = {};
        // this.stocks = [];
        //this.portfolioSummaryData.value = null;
        //this.portfoliosCardData.value = [];
    }
}